import { DateTimeFormatter, Instant, ZoneId } from '@js-joda/core';
const filenameDateTimeFormatter = DateTimeFormatter.ofPattern('yyyy-MM-dd HH-mm-ss');
export const generateExportTimestamp = () => filenameDateTimeFormatter.format(Instant.now().atZone(ZoneId.systemDefault()));
export const saveFile = (filename, data, type = 'application/json') => {
    const blob = new Blob([data], { type });
    try {
        // try to use the old IE method if it exists
        window.navigator['msSaveBlob'](blob, filename);
    }
    catch {
        const elem = window.document.createElement('a');
        elem.href = window.URL.createObjectURL(blob);
        elem.download = filename;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
    }
};
export const requireIndex = (data, value) => {
    const idx = data.findIndex((v) => v.toLowerCase() === value.toLowerCase());
    if (idx === -1) {
        throw new Error(`unable to find index of '${value}'`);
    }
    return idx;
};
export const searchCSVIndex = (data, value) => {
    const idx = data.findIndex((v) => v.toLowerCase().includes(value.toLowerCase()));
    if (idx === -1) {
        return undefined;
    }
    return idx;
};
export const checkCSVHeader = (header) => {
    if (header.length < 3 ||
        !header.some((value) => value.toLocaleLowerCase() === 'symbol') ||
        !header.some((value) => value.toLocaleLowerCase() === 'quantity') ||
        !header.some((value) => value.toLocaleLowerCase() === 'price')) {
        return false;
    }
    return true;
};
